var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueUpArrowIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrowBtn-16px"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.477 10.3821C13.7441 10.6436 13.7441 11.0735 13.477 11.3349L13.2793 11.5285C13.0201 11.7822 12.6057 11.7822 12.3466 11.5285L7.96365 7.23797L3.58075 11.5285C3.32159 11.7822 2.90719 11.7822 2.64803 11.5285L2.45031 11.3349C2.18323 11.0735 2.18323 10.6436 2.45031 10.3821L7.49729 5.44153C7.75645 5.18784 8.17086 5.18784 8.43001 5.44153L13.477 10.3821Z",
    fill: "#0047FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.62519 10.5608C2.45827 10.7242 2.45827 10.9929 2.62519 11.1563L2.82292 11.3498C2.98489 11.5084 3.24389 11.5084 3.40586 11.3498L7.96365 6.88812L12.5214 11.3498C12.6834 11.5084 12.9424 11.5084 13.1044 11.3498L13.3021 11.1563C13.469 10.9929 13.469 10.7242 13.3021 10.5608L8.25512 5.62018C8.09315 5.46163 7.83415 5.46163 7.67218 5.62018L2.62519 10.5608ZM2.27543 11.5136C1.90819 11.1541 1.90819 10.563 2.27543 10.2035L7.32241 5.26288C7.67875 4.91406 8.24856 4.91406 8.60489 5.26288L13.6519 10.2035C14.0191 10.563 14.0191 11.1541 13.6519 11.5136L13.4542 11.7071C13.0978 12.056 12.528 12.056 12.1717 11.7071L7.96365 7.58782L3.75563 11.7071C3.39929 12.056 2.82949 12.056 2.47315 11.7071L2.27543 11.5136Z",
    fill: "#0047FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueUpArrowIcon);
export default __webpack_public_path__ + "static/media/blueUpArrowIcon.7e04769ef618ab3d36c07920c511177a.svg";
export { ForwardRef as ReactComponent };